import type { CartItem } from '@features/cart/types';
import { mergeCartItems } from './cartEngine';

export interface CartMergeResult {
  items: CartItem[];
  mergedLineCount: number;
}

export function mergeAnonymousCartIntoUserCart(
  userItems: readonly CartItem[],
  anonymousItems: readonly CartItem[]
): CartMergeResult {
  const items = mergeCartItems(userItems, anonymousItems);
  return {
    items,
    mergedLineCount: anonymousItems.length,
  };
}
